// libraries
import { css } from 'styled-components';

// chartDashboard box style
export const chartDashboardBoxStyle = css`
  width: 100%;
  min-width: 434px;
  min-height: 290px;
  padding: 14px 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 6px rgba(100, 26, 26, 0.15);
`;

// chartDashboard type01 style
export const chartDashboardType01Style = css`
  min-width: 434px;
  width: 100%;
  height: 340px;

  .entry-lists {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 56px;
    padding: 10px 13px;
    margin-top: 23px;
    margin-bottom: 42px;
    border-radius: 4px;
    background-color: #f8f8f8;
    border: 1px solid #e4e4e4;

    li {
      display: flex;
      align-items: center;

      /* &:not(:last-child) {
        &::after {
          content: '';
          display: inline-block;
          width: 1px;
          height: 34px;
          background-color: #e4e4e4;
          margin: 0 13px;
        }
      } */
    }

    .divider {
      content: '';
      display: inline-block;
      width: 1px;
      height: 34px;
      background-color: #e4e4e4;
      margin: 0 13px;
    }

    h3 {
      font-size: 14px;
      font-weight: 500;
      margin-right: 24px;
    }

    p {
      font-size: 26px;
      font-weight: 500;
    }
  }

  .today-lists {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 13px;

    .total {
      min-width: 130px;
      width: 130px;
      height: 132px;
      padding: 10px 8px 8px;
      border-radius: 10px;
      text-align: center;

      &-general {
        background-color: #f1e9dc;

        h3,
        h4,
        p {
          color: #987021;
        }
      }

      &-risk {
        background-color: #f8eded;

        h3,
        h4,
        p {
          color: #b60d0d;
        }
      }

      h3 {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;

        &::after {
          content: '';
          display: inline-block;
          width: 100%;
          height: 1px;
          margin: 7px 0 6px;
          background-color: rgba(152, 112, 33, 0.2);
        }
      }

      h4 {
        font-size: 10px;
        font-weight: 500;
      }

      p {
        font-size: 22px;
        font-weight: 500;
      }

      .work-lists {
        display: flex;
        flex-direction: column;
        gap: 4px;

        li {
          display: flex;
          flex-direction: column-reverse;
          justify-content: center;
          min-height: 40px;
          background-color: #fff;
          border-radius: 4px;
        }
      }
    }

    .table {
      &-wrapper {
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid #dadada;
      }

      &-lists {
        width: 100%;
        border-collapse: collapse;

        thead {
          background-color: #f4f4f4;
          font-weight: bold;
        }

        th,
        td {
          text-align: center;
        }

        th {
          font-size: 13px;
          font-weight: 500;
          border-bottom: 1px solid #dadada;
          padding: 7px 13px 6px;
        }

        td {
          font-size: 22px;
          font-weight: 500;
          border: 1px solid #ccc;
          background-color: white;

          small {
            display: block;
            font-size: 10px;
            font-weight: 500;
            color: #b7b7b7;
            margin-top: 2px;
          }
        }

        tbody {
          border-collapse: separate;
          border-spacing: 10px;
        }
      }
    }
  }

  .today-list {
    display: flex;
    gap: 10px;
  }

  @media (max-width: 1919px) {
    width: 100%;

    .today-lists {
      .total {
        width: 30%;
      }
    }
  }

  @media (max-width: 1023px) {
    height: auto;
  }
`;

// chartDashboard type02 style
export const chartDashboardType02Style = css`
  position: relative;
  min-width: 434px;
  width: 300px;
  height: 151px;
  padding: 14px 20px;

  .pjt-lists {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 17px;

    .pjt-list {
      display: flex;
      line-height: 21px;

      h3 {
        min-width: 120px !important;
        font-size: 14px;
        font-weight: 500;
      }

      p {
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  @media (max-width: 1919px) {
    width: 100%;
  }
`;
export const chartDashboardType02SamsungStyle = css`
  position: relative;
  min-width: 434px;
  width: 100%;
  height: 151px;
  padding: 14px 20px;

  .pjt-lists {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 17px;

    .pjt-list {
      display: flex;
      line-height: 21px;

      h3 {
        min-width: 120px !important;
        font-size: 14px;
        font-weight: 500;
      }

      p {
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  @media (max-width: 1919px) {
    width: 100%;
  }
`;

// chartDashboard type03 style
export const chartDashboardType03Style = css`
  position: relative;
  min-width: 931px;
  width: 931px;
  height: 260px;

  h2 {
    margin-bottom: 20px;
  }

  .entry-graph {
    margin-left: 16px;
  }

  .wing {
    position: absolute;
    top: 14px;
    right: 15px;
    display: flex;
    align-items: center;
    gap: 19px;

    &-lists {
      display: flex;
      gap: 17px;
    }

    &-list {
      span {
        font-size: 14px;
        font-weight: 500;
        margin-left: 10.5px;
      }
    }

    p {
      display: flex;
      align-items: center;
      min-height: 28px;
      padding: 4px 10px 4px 11px;
      border-radius: 4px;
      background-color: #f8f8f8;
      border: 1px solid #e4e4e4;
      font-size: 14px;
      font-weight: 500;
      color: #000;
    }
  }

  @media (max-width: 1023px) {
    height: auto;
  }
`;

// chartDashboard type04 style
export const chartDashboardType04Style = css`
  min-width: 218px;
  width: 218px;
  height: 308px;
  padding: 14px 12px;

  h2 {
    max-width: 160px;
    margin-left: 8px;
    line-height: 20px;
  }

  .graph-container {
    position: relative;
    width: 116px;
    height: 114px;
    margin: 14px auto 13px;

    .total-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;

      h3 {
        font-size: 14px;
        font-weight: 500;
      }

      span {
        font-size: 26px;
        font-weight: 500;
      }
    }

    .graph {
      width: 116px;
      height: 114px;
    }
  }

  .risk-graph {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 13px 14px 24px;
    margin-top: 18px;
    margin-bottom: 25px;
    border-radius: 4px;
    background-color: #f8f8f8;
    border: 1px solid #e4e4e4;

    .total-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 35px;

      h3 {
        font-size: 14px;
        font-weight: 500;
      }

      span {
        font-size: 14px;
        font-weight: 500;

        em {
          font-size: 26px;
          font-weight: 500;
          font-style: normal;
        }
      }
    }

    .total-graph {
      height: 16px;
    }
  }

  .status {
    &-lists {
      display: flex;
      flex-direction: column;
      gap: 8px;

      &.lead {
        gap: 4px;
      }
    }

    &-list {
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-left: 10px;
      padding-left: 20px;
      line-height: 21px;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background-color: #66470b;
      }

      &.66470b {
        &::before {
          background-color: #66470b;
        }
      }

      &.CFA04A {
        &::before {
          background-color: #cfa04a;
        }
      }

      &.C02C2E {
        &::before {
          background-color: #c02c2e;
        }
      }

      &--ex {
        &::before {
          background-color: #f01d1d;
        }
      }

      &--hi {
        &::before {
          background-color: #b2191b;
        }
      }

      &--mo {
        &::before {
          background-color: #ffa84c;
        }
      }

      &--lo {
        &::before {
          background-color: #ffc658;
        }
      }

      &--go {
        &::before {
          background-color: #66470b;
        }
      }

      &--ap {
        &::before {
          background-color: #cfa04a;
        }
      }

      &--de {
        &::before {
          background-color: #c02c2e;
        }
      }

      &--be {
        &::before {
          background-color: #ffd27a;
        }
      }

      &--ch {
        &::before {
          background-color: #cfa04a;
        }
      }

      &--co {
        &::before {
          background-color: #66470b;
        }
      }

      h4 {
        font-size: 14px;
        font-weight: 400;
      }

      p {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .line-break {
    padding-right: 60px;
  }

  @media (max-width: 1023px) {
    height: auto;
  }
`;

// chartDashboard type05 style
export const chartDashboardType05Style = css`
  min-width: 929px;
  width: 929px;
  height: 587px;
  padding: 14px 15px;

  h2 {
    margin-bottom: 18px;
  }

  .temp-lists {
    display: flex;
    gap: 18px;
    margin-bottom: 13px;

    .temp-list {
      position: relative;
      min-width: 437px;
      width: 50%;
      height: 157px;
      padding: 14px 21px;
      border-radius: 10px;
      background-color: #f8f8f8;
      border: 1px solid #e4e4e4;

      .temp-contents {
        display: flex;
        align-items: center;
        gap: 20px;
      }

      .temp-texts {
        display: flex;
        flex-direction: column;

        .temp {
          font-size: 11px;
          font-weight: 500;
          margin-bottom: 6px;

          em {
            font-size: 26px;
            font-weight: 500;
            font-style: normal;
            margin-right: 10px;
          }
        }

        .desc {
          font-size: 12px;
          font-weight: 400;
          color: #585959;
        }

        ul {
          display: flex;
          gap: 11px;
        }
      }

      &--outside {
        .wing {
          position: absolute;
          top: 12px;
          left: 102px;
          display: inline-flex;
          align-items: center;
          min-height: 24px;
          border-radius: 20px;
          background-color: #e5e5e5;
          padding: 2px 8px;
        }
      }

      &--index {
        .wing {
          .btn-alert {
            position: absolute;
            top: 16px;
            right: 16px;
            display: inline-flex;
            align-items: center;
            min-height: 33px;
            border-radius: 4px;
            background-color: #b38b3a;
            padding: 6px 16px;
            color: #fff;
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
    }
  }

  .graph-lists {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;

    .graph-list {
      margin-left: 21px;

      h2 {
        margin-bottom: 0.23px;
      }
    }
  }

  @media (max-width: 1023px) {
    height: auto;

    .temp-lists {
      flex-direction: column;

      .temp-list {
        width: 100%;
      }
    }

    .graph-lists {
      display: flex;
      flex-direction: column;
    }
  }
`;

// chartDashboard table-wrapper style
export const chartDashboardTableWrapperStyle = css`
  .table-wrapper {
    width: 100%;
    border-radius: 10px;
    background-color: #fff;
    border: 1px solid #dadada;
    height: 132px;

    .table-title {
      display: flex;
      justify-content: space-around;
      padding: 6px 0;
      /* border-radius: 0 0 10px 0; */
      background-color: #f4f4f4;
      border-bottom: 1px solid #dadada;

      li {
        font-size: 13px;
        font-weight: 500;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(100% / 3);
      }
    }

    .table-value {
      display: flex;
      justify-content: space-evenly;
      margin-top: 3px;

      .value-list {
        position: relative;
        width: calc(100% / 3);

        &:not(:last-child) {
          &:after {
            content: '';
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            display: block;
            width: 1px;
            height: 74px;
            background-color: #dadada;
            box-sizing: inherit;
          }
        }

        .value-section {
          display: flex;
          flex-direction: column;

          .section-list {
            display: flex;
            flex-direction: column-reverse;
            align-items: center;
            gap: 0px;

            &:not(:last-child) {
              &::before {
                content: '';
                display: block;
                width: 72%;
                height: 1px;
                background-color: #dadada;
                margin: 1px 0 4px;
                box-sizing: inherit;
              }
            }

            h4 {
              font-size: 10px;
              font-weight: 500;
              color: #b7b7b7;
            }

            p {
              font-size: 22px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
`;
